import * as React from 'react'
import {Box} from "@mui/material";
import { translateCountryName } from "@ui-seeker/utils"

import { LabelCountry } from "@components";


export default function countryColumn() {
    return [{
        name: 'country',
        label: 'Country',
        options: {
            display: 'excluded',
            customBodyRowRender: v => translateCountryName(v)
        }
    },{
        name: 'country', label: 'Country',
        options: {
            headerAlign: 'left',
            filter: false,
            customBodyRowRenderLite: (value) => <Box>
                <LabelCountry country={value} label={translateCountryName(value)} />
            </Box>
        }
    }]
}